import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';

const FavCtx = createContext(null);
export const useFavorites = () => useContext(FavCtx);

const sid = (v) => String(v ?? '');

function readLS() {
  try {
    // миграция со старого ключа — один раз
    const legacy = localStorage.getItem('ls_wishlist_v1');
    if (legacy) {
      const arr = JSON.parse(legacy);
      if (Array.isArray(arr) && arr.length) {
        localStorage.setItem('fav', JSON.stringify(arr.map(sid)));
      }
      localStorage.removeItem('ls_wishlist_v1');
    }

    const raw = localStorage.getItem('fav');
    const ids = Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : [];
    return Array.from(new Set(ids.map(sid).filter(Boolean)));
  } catch {
    return [];
  }
}

function writeLS(ids) {
  try { localStorage.setItem('fav', JSON.stringify(ids)); } catch {}
}

const ACT = { TOGGLE: 'TOGGLE', ADD: 'ADD', REMOVE: 'REMOVE', CLEAR: 'CLEAR' };

function reducer(state, action) {
  switch (action.type) {
    case ACT.TOGGLE: {
      const id = sid(action.id);
      const set = new Set(state);
      set.has(id) ? set.delete(id) : set.add(id);
      return Array.from(set);
    }
    case ACT.ADD: {
      const id = sid(action.id);
      const set = new Set(state); set.add(id);
      return Array.from(set);
    }
    case ACT.REMOVE:
      return state.filter(x => x !== sid(action.id));
    case ACT.CLEAR:
      return [];
    default:
      return state;
  }
}

export function FavoritesProvider({ children }) {
  const [ids, dispatch] = useReducer(reducer, [], readLS);

  useEffect(() => { writeLS(ids); }, [ids]);

  const api = useMemo(() => ({
    ids,
    count: ids.length,
    has: (id) => ids.includes(sid(id)),
    toggle: (id) => dispatch({ type: ACT.TOGGLE, id }),
    add: (id) => dispatch({ type: ACT.ADD, id }),
    remove: (id) => dispatch({ type: ACT.REMOVE, id }),
    clear: () => dispatch({ type: ACT.CLEAR })
  }), [ids]);

  return <FavCtx.Provider value={api}>{children}</FavCtx.Provider>;
}
